import React, { type ReactNode, useMemo } from 'react';

import './Pill.scss';

interface YatPillProps {
    variant?: 'danger' | 'warning' | null;
    size?: 'tiny' | 'small' | 'large' | null;
    children?: ReactNode;
    classes?: string;
}

export const YatPill = ({ variant, size, children, classes = '' }: YatPillProps) => {
    const classNames = useMemo(() => {
        let classNames = 'yat-pill';
        if (variant) classNames += ` yat-pill--${variant}`;
        if (size) classNames += ` yat-pill--${size}`;
        if (classes) classNames += ` ${classes}`;

        return classNames;
    }, [variant, size, classes]);

    return <span className={classNames}>{children}</span>;
};
